import { getCart } from "@dana/Overrides/Services/CartService";
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { Cart, GetCartApiParameter } from "@insite/client-framework/Services/CartService";

interface Props {
    apiParameter: GetCartApiParameter;
    apiResult: Cart;
    errorMessage: string | undefined;
}
type HandlerType = Handler<GetCartApiParameter & HasOnSuccess<Cart>, Props>;

export const SetParameters: HandlerType = props => {
  
    props.apiParameter = {
        ...props.parameter,
        cartId: props.parameter.cartId, 
        expand: ['validation', 'cartLines', 'costCodes', 'hiddenproducts', 'carriers'],
         forceRecalculation: false,
        allowInvalidAddress: true,
        additionalQueryStringParameters: { 
            "IsEmergencyOrder": "true",             
        },
    };

    props.dispatch?.({ type: "EmergencyCart/Start" } as any);
};

export const GetUserCarts: HandlerType = async props => {
    try {
        const apiResult = await getCart(props.apiParameter);
        const cart = apiResult.cart;     

        props.apiResult = cart;
        props.dispatch?.({
            type: "EmergencyCart/LoadResponse",
            cart,
        } as any);
    } catch (error) {
        props.errorMessage = String(error);      
        props.dispatch?.({ type: "EmergencyCart/End" } as any);
    }
};

export const SetLoadingOff: HandlerType = props => {
    props.dispatch?.({ type: "EmergencyCart/End" } as any);
    if (!props.errorMessage && props.parameter.onSuccess) {
        props.parameter.onSuccess(props.apiResult);
    }
};
export const chain = [
    SetParameters,
    GetUserCarts,
    SetLoadingOff
];

const loadEmergencyCart = createHandlerChainRunner(chain, "EmergencyCart");
export default loadEmergencyCart;